import { urlConfig } from "../../config/urlConfig";
import { DocumentView, RequestModel } from "../../types/SimpleSearchModel";
import { DocumentViewerRequestModel } from "../../types/DocumentViewerModel";
import { postCall, postFileDownloadCall } from "../httpService";

const baseUrl = process.env.REACT_APP_API_URL;
const simpleSearchUrl = urlConfig.SimpleSearch;
const downFileUrl = urlConfig.Searchfiledownload;
const infoUrl = urlConfig.fileInformation;
const deleteDocUrl = urlConfig.deleteDocuments;
const multipleDocsDownloadUrl = urlConfig.multipleDocumentsDownload;
const documentViewerUrl = urlConfig.documentViewer;

export const getSimpleSearchData = async (simpleSearchModel: RequestModel) => {
  try {
    const response = await postCall(simpleSearchUrl, simpleSearchModel);
    return response.data;
  } catch (error) {
    console.error("Error fetching SimpleSearchData", error);
    throw error;
  }
};

export const multipleDownloadFile = async (downloadFilePayLoad: any) => {
  try {
    const response = await postFileDownloadCall(
      multipleDocsDownloadUrl,
      downloadFilePayLoad
    );
    return response;
  } catch (error) {
    console.error("Error fetching MultipleDownloadFile", error);
    throw error;
  }
};

export const downloadFile = async (downloadFilePayLoad: any) => {
  try {
    const response = await postFileDownloadCall(
      downFileUrl,
      downloadFilePayLoad
    );
    return response;
  } catch (error) {
    console.error("Error fetching DownloadFile", error);
    throw error;
  }
};

export const getInfoData = async (infoPayLoad: any) => {
  try {
    const response = await postCall(infoUrl, infoPayLoad);
    return response.data;
  } catch (error) {
    console.error("Error fetching InfoData", error);
    throw error;
  }
};

export const deleteDocuments = async (docPayload: DocumentView[]) => {
  try {
    const response = await postCall(deleteDocUrl, docPayload);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error("Error in DeleteDocuments", error);
    throw error;
  }
};

export const getDocumentViewer = async (
  docPayload: DocumentViewerRequestModel
) => {
  try {
    const response = await postCall(documentViewerUrl, docPayload);
    return response.data;
  } catch (error) {
    console.error("Error fetching getDocumentViewer", error);
    throw error;
  }
};
